import { useLocation } from 'react-router-dom';

export default function withRouterLocationHook(Component) {
    return function WrappedComponent(props) {
        const location = useLocation();
        return <Component location={location} {...props} />;
    };
};